import { EnvVars } from './EnvVars'
import Cookie from 'js-cookie'

export const fetcher = (input: RequestInfo, init: RequestInit): Promise<Response> => {
  // Fire off a dummy request to get the CSRF token if one's missing
  const pre = document.cookie.includes('x-csrf-token')
    ? Promise.resolve({ 'csrf-token': Cookie.get('x-csrf-token') })
    : window.fetch(`${EnvVars.API_URL}/helo`, { credentials: 'include' }).then(response => response.json())
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  return pre.then(({ 'csrf-token': token }) => {
    init.headers = init.headers || {}
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    init.headers['x-csrf-token'] = token

    return window.fetch(input, init)
  })
}
